import React, { ChangeEvent, FC, useCallback, useState } from 'react';
import Card from 'src/components/Card';
import CardTitle from 'src/components/CardTitle';
import { Grid, TextField } from '@material-ui/core';
import Button from 'src/components/Button';

interface Props {
  onSubmit: (data: { queryString?: string }) => void;
}

const SearchCard: FC<Props> = ({ onSubmit }) => {
  const [queryString, setQueryString] = useState('');

  const handleQueryChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setQueryString(event.target.value || '');
    },
    [setQueryString]
  );

  const handleSubmit = useCallback(() => {
    onSubmit({ queryString: queryString.replace(/([^0-9a-zA-Z ])/g, '\\$1') });
  }, [queryString]);

  return (
    <Card className='mb-4'>
      <CardTitle title='Que recherchez-vous ?' />

      <Grid container spacing={2}>
        <Grid item xs>
          <TextField
            size='small'
            onChange={handleQueryChange}
            value={queryString}
            variant='outlined'
            label='Chercher une reference'
            placeholder='Ecran 24", Casque Jabra, ...'
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>

        <Grid item xs='auto'>
          <Button variant='contained' color='primary' onClick={handleSubmit}>
            Chercher
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

export default SearchCard;
